/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { Heading } from '@zapier/legacy-components';
import { css, jsx } from '@emotion/core';

const rootCss = css({
  color: Colors.deepSpace,
});

function IntegrationListHeader() {
  return (
    <Heading css={rootCss} kind="bold 20">
      Integrations
    </Heading>
  );
}

export default IntegrationListHeader;
